/**
 * AMPI Riviera Nayarit - Datos de Convenios Locales
 * Migrado desde Módulo A - Enero 2026
 */

export interface Convenio {
  id: string;
  slug: string;
  nombre: string;
  nombreCorto: string;
  categoria: string;
  categoriaLabel: string;
  logo: string | null;
  tieneLogoReal: boolean;
  descripcion: string;
  beneficios: string[];
  condiciones: string[];
  vigencia: string | null;
  pdfUrl: string | null;
  redesSociales: {
    facebook: string | null;
    instagram: string | null;
  };
  destacado: boolean;
}

export interface Categoria {
  id: string;
  label: string;
  count?: number;
}

export const CONVENIOS_DATA: Convenio[] = [
  // ========== EDUCACION (1) ==========
  {
    id: "utbb",
    slug: "utbb",
    nombre: "Universidad Tecnológica de Bahía de Banderas",
    nombreCorto: "UTBB",
    categoria: "educacion",
    categoriaLabel: "Educación",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Esta colaboración promueve foros, programas académicos y credenciales profesionales que se consolidan como referente nacional en desarrollo inmobiliario y educación aplicada.",
    beneficios: [
      "Foro Inmobiliario UTBB-AMPI: Encuentros anuales con empresarios y expertos del sector",
      "Microcredenciales y diplomado inmobiliario con validez académica",
      "Impulso a la Ley de Profesionalización Inmobiliaria en Nayarit",
      "Licenciatura en Negocios Inmobiliarios (en planeación)"
    ],
    condiciones: [],
    vigencia: null,
    pdfUrl: null,
    redesSociales: { facebook: null, instagram: null },
    destacado: true
  },

  // ========== GASTRONOMIA ==========
  {
    id: "canirac",
    slug: "alianza-canirac",
    nombre: "Alianza Estratégica AMPI - CANIRAC",
    nombreCorto: "CANIRAC",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Colaboración que fortalece la vinculación entre el sector inmobiliario y restaurantero de la región, generando sinergias para promover el consumo local.",
    beneficios: [
      "Mínimo 10% de descuento en Restaurantes Participantes",
      "Aplica para Certificados de regalo",
      "Servicios de Catering con algunos participantes",
      "Sabores AMPI: Encuentros mensuales en restaurantes de la región",
      "Café Inmobiliario: Desayunos de networking en sedes rotativas"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/CANIRACVALLARTA",
      instagram: "https://www.instagram.com/caniracvallarta/"
    },
    destacado: true
  },
  {
    id: "marissimo",
    slug: "marissimo",
    nombre: "Marissimo",
    nombreCorto: "Marissimo",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Restaurante especializado en mariscos frescos con beneficios exclusivos para la comunidad AMPI.",
    beneficios: [
      "10% de descuento en consumo",
      "Cena o comida gratis para el cumpleañero",
      "Reservaciones preferenciales"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/marissimo.mx",
      instagram: "https://www.instagram.com/marissimo.mx/"
    },
    destacado: false
  },
  {
    id: "cafe-des-artistes",
    slug: "cafe-des-artistes",
    nombre: "Café des Artistes",
    nombreCorto: "Café des Artistes",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Restaurante de alta cocina con ambiente artístico, descuentos para miembros AMPI.",
    beneficios: [
      "20% de descuento para asociados y afiliados",
      "Válido en todas sus marcas"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: { facebook: null, instagram: null },
    destacado: true
  },
  {
    id: "samurai",
    slug: "samurai",
    nombre: "Samurai PV",
    nombreCorto: "Samurai",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Gastronomía japonesa de alta calidad con precios especiales para miembros AMPI.",
    beneficios: [
      "10% de descuento en consumo",
      "Cena o comida gratis para el cumpleañero",
      "Menús especiales para eventos"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/samuraisushimexico",
      instagram: "https://www.instagram.com/samuraisushipv/"
    },
    destacado: false
  },
  {
    id: "al-grano-cafe",
    slug: "al-grano-cafe",
    nombre: "Al Grano Café",
    nombreCorto: "Al Grano Café",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Café de especialidad con descuentos exclusivos para miembros AMPI.",
    beneficios: [
      "10% de descuento en todos los productos comestibles",
      "15% de descuento en rebanadas de pastel"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/algranocafepv",
      instagram: "https://www.instagram.com/algranocafepv/"
    },
    destacado: false
  },

  // ========== SALUD ==========
  {
    id: "diagnostik",
    slug: "diagnostik",
    nombre: "Grupo Diagnosti-K",
    nombreCorto: "Diagnosti-K",
    categoria: "salud",
    categoriaLabel: "Salud",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Acceso preferencial a servicios médicos, estudios de laboratorio e imagenología para la comunidad AMPI.",
    beneficios: [
      "Descuentos del 10% al 20% en estudios de imagen y laboratorio",
      "Acceso en hospitales aliados: Joya Nuevo Vallarta, Hospiten, MedAssist",
      "Tarjeta Digital AMPI con QR institucional",
      "App Diagnosti-K para consulta de resultados y citas",
      "Tecnología médica avanzada con inteligencia artificial"
    ],
    condiciones: [],
    vigencia: null,
    pdfUrl: null,
    redesSociales: { facebook: null, instagram: null },
    destacado: true
  },
  {
    id: "sammer-spa",
    slug: "sammer-spa",
    nombre: "Sammer SPA",
    nombreCorto: "Sammer SPA",
    categoria: "salud",
    categoriaLabel: "Salud",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Servicios de cosmetología y relajación con beneficios exclusivos para miembros AMPI.",
    beneficios: [
      "10% de descuento incluso sobre promociones vigentes",
      "Servicios de cosmetología profesional",
      "Tratamientos de relajación y bienestar"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/profile.php?id=61574726173860",
      instagram: "https://www.instagram.com/samer.spa/"
    },
    destacado: false
  },
  {
    id: "barbero",
    slug: "barbero",
    nombre: "Barbero Barber Shop & Tatoos",
    nombreCorto: "Barbero",
    categoria: "salud",
    categoriaLabel: "Salud",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Barbería profesional con servicios de corte y tatuajes, con beneficios exclusivos para miembros AMPI.",
    beneficios: [
      "10% de descuento en cualquiera de sus 4 sucursales",
      "Servicios de barbería profesional",
      "Atención preferencial"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/barberoconacento",
      instagram: "https://www.instagram.com/barberoconacento/"
    },
    destacado: false
  },

  // ========== SERVICIOS ==========
  {
    id: "alambrados-navarro",
    slug: "alambrados-navarro",
    nombre: "Alambrados Navarro",
    nombreCorto: "Alambrados Navarro",
    categoria: "servicios",
    categoriaLabel: "Servicios",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Servicios de seguridad y cercados perimetrales con beneficios exclusivos para miembros AMPI.",
    beneficios: [
      "20% de descuento en Malla Ciclónica",
      "15% de descuento en Rejas de Acero",
      "15% de descuento en Cerca electrificada",
      "3% de descuento en Muros ligeros de WPC"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/alambradosnavarro",
      instagram: "https://www.instagram.com/alambradosnavarro/"
    },
    destacado: false
  },
  {
    id: "impresiones-mexicanas",
    slug: "impresiones-mexicanas",
    nombre: "Impresiones Mexicanas",
    nombreCorto: "Impresiones Mexicanas",
    categoria: "servicios",
    categoriaLabel: "Servicios",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Servicios de imprenta, serigrafía, impresión digital e impresión de lonas y señalética.",
    beneficios: [
      "15% de descuento en papelería impresa, offset e impresión digital",
      "10% de descuento en lona impresa (a partir de 3 m²), incluye diseño sin costo",
      "15% de descuento en lona impresa pagando en efectivo",
      "Promoción especial: playera impresa a $95 MXN (1-2 colores, mínimo 50 piezas)"
    ],
    condiciones: ["Presentar credencial AMPI vigente", "Máximo 2 cambios de diseño incluidos"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: { facebook: null, instagram: null },
    destacado: false
  },
  {
    id: "ingenieria-electrica",
    slug: "ingenieria-electrica",
    nombre: "Servicios en Ingeniería Eléctrica",
    nombreCorto: "Ing. Eléctrica",
    categoria: "servicios",
    categoriaLabel: "Servicios",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Servicios profesionales de instalaciones eléctricas en media y baja tensión.",
    beneficios: [
      "10% de descuento en verificación de instalaciones eléctricas",
      "15% de descuento para proyectos eléctricos UVIE",
      "10% de descuento en servicios de gestoría ante CFE",
      "5% de descuento en obra eléctrica media y baja tensión"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: { facebook: null, instagram: null },
    destacado: false
  },
  {
    id: "peterinaria-petpark",
    slug: "peterinaria-petpark",
    nombre: "PETerinaria / PETpark",
    nombreCorto: "PETerinaria",
    categoria: "servicios",
    categoriaLabel: "Servicios",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Servicios veterinarios y hotel para mascotas con beneficios exclusivos para miembros AMPI.",
    beneficios: [
      "10% de descuento en servicio de baño o estética",
      "Baño gratis posterior a servicio de hotel en PETpark",
      "Atención veterinaria profesional"
    ],
    condiciones: [
      "Presentar credencial AMPI vigente",
      "No aplicable en mascotas recién rescatadas con pulgas, garrapatas o sin vacunas previas"
    ],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/peterinariaPV",
      instagram: "https://www.instagram.com/peterinariapv/"
    },
    destacado: false
  },

  // ========== EXPERIENCIAS ==========
  {
    id: "ada-sailing",
    slug: "ada-sailing",
    nombre: "ADA Sailing",
    nombreCorto: "ADA Sailing",
    categoria: "experiencias",
    categoriaLabel: "Experiencias",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Experiencias de navegación en veleros Ada y Bruna exclusivas para miembros AMPI en la Bahía de Banderas.",
    beneficios: [
      "15% de descuento en tours de velero",
      "Experiencias exclusivas en Bahía de Banderas",
      "Eventos de networking en el mar"
    ],
    condiciones: ["Presentar credencial AMPI vigente"],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/vallartasailing",
      instagram: "https://www.instagram.com/adasailing/"
    },
    destacado: false
  },
  {
    id: "mikes-fishing",
    slug: "mikes-fishing",
    nombre: "Mikes Fishing",
    nombreCorto: "Mikes Fishing",
    categoria: "experiencias",
    categoriaLabel: "Experiencias",
    logo: null,
    tieneLogoReal: false,
    descripcion: "Renta de embarcaciones privadas, yates y lanchas de pesca deportiva y tours turísticos en Bahía de Banderas.",
    beneficios: [
      "25% de descuento en renta de Yates Privados",
      "25% de descuento en renta de Lanchas de Pesca o Paseo",
      "30% de descuento en renta de Catamaranes"
    ],
    condiciones: [
      "Presentar credencial AMPI vigente al reservar",
      "Reservación con 48 horas de anticipación",
      "Sujeto a disponibilidad",
      "No acumulable con otras promociones"
    ],
    vigencia: null,
    pdfUrl: null,
    redesSociales: {
      facebook: "https://www.facebook.com/mikesfishingtours",
      instagram: "https://www.instagram.com/mikes_fishingtours/"
    },
    destacado: true
  }
];

// Categorías disponibles con contadores calculados
export const CATEGORIAS_CONVENIOS: Categoria[] = [
  { id: "todos", label: "Todos", count: CONVENIOS_DATA.length },
  { id: "gastronomia", label: "Gastronomía", count: CONVENIOS_DATA.filter(c => c.categoria === "gastronomia").length },
  { id: "salud", label: "Salud", count: CONVENIOS_DATA.filter(c => c.categoria === "salud").length },
  { id: "servicios", label: "Servicios", count: CONVENIOS_DATA.filter(c => c.categoria === "servicios").length },
  { id: "educacion", label: "Educación", count: CONVENIOS_DATA.filter(c => c.categoria === "educacion").length },
  { id: "experiencias", label: "Experiencias", count: CONVENIOS_DATA.filter(c => c.categoria === "experiencias").length }
];

// Iconos SVG por categoría
export const CATEGORIA_ICONS: Record<string, string> = {
  educacion: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>',
  gastronomia: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/></svg>',
  salud: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>',
  servicios: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 7h-4V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5z"/></svg>',
  experiencias: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>'
};

// Helper para obtener convenios destacados
export const getConveniosDestacados = () => CONVENIOS_DATA.filter(c => c.destacado);

// Helper para filtrar por categoría
export const getConveniosByCategoria = (categoria: string) =>
  categoria === 'todos' ? CONVENIOS_DATA : CONVENIOS_DATA.filter(c => c.categoria === categoria);
